import { solana, solanaDevnet } from '@reown/appkit/networks';

import { isDev } from '@/constants';

export const getSolanaNetwork = () => (isDev ? solanaDevnet : solana);
